if (!window.StockCubeCore) window.StockCubeCore = {};

window.StockCubeCore.updateTimelineProgress = function (time, index, total) {
    if (this.data.timelineEntity) {
        this.data.timelineEntity.emit('timeline-update', {
            timestamp: time,
            index: index,
            total: total
        }, true);
    }
};

window.StockCubeCore.cancelTimelineAnimation = function (timelineEntity) {
    if (timelineEntity && timelineEntity.components['timeline-control']) {
        const tl = timelineEntity.components['timeline-control'];
        tl.isAnimating = false;
        tl.currentAnimationSession = (tl.currentAnimationSession || 0) + 9999;
        if (typeof tl.updatePlayButtonIcon === 'function') tl.updatePlayButtonIcon(false);
        if (__LOG_INFO__) AppLog.info('[Stock Visualizer] Forcefully cancelled lingering manual timeline loops.');
    }
};

window.StockCubeCore.gotoTimestamp = function (timestamp, index) {
    if (__LOG_INFO__) AppLog.info(`Received goto-time: timestamp=${timestamp}, index=${index}`);

    if (!this.currentData) {
        if (__LOG_WARN__) AppLog.warn('Cannot goto timestamp: no data available yet');
        return;
    }

    const { intervals } = this.currentData;
    if (!intervals) {
        if (__LOG_WARN__) AppLog.warn('No intervals data available');
        return;
    }

    const isMultiDay = this.data.interval && this.data.interval !== '1d';
    let searchTimestamp = timestamp;

    if (isMultiDay) {
        if (typeof timestamp === 'string') {
            if (timestamp.includes(' ')) {
                searchTimestamp = timestamp.split(' ')[0];
            } else if (timestamp.includes('T')) {
                searchTimestamp = timestamp.split('T')[0];
            }
        }
        if (__LOG_INFO__) AppLog.info(`Multiday mode: normalized timestamp from "${timestamp}" to "${searchTimestamp}"`);
    } else {
        if (__LOG_INFO__) AppLog.info(`Single day mode: using full timestamp "${timestamp}"`);
    }

    if (!intervals[searchTimestamp]) {
        if (__LOG_WARN__) AppLog.warn(`No data for timestamp ${searchTimestamp}`);
        const availableTimestamps = Object.keys(intervals).sort();
        if (__LOG_INFO__) AppLog.info('Available timestamps:', availableTimestamps.slice(0, 5), '...', availableTimestamps.slice(-5));
        return;
    }

    const stocks = intervals[searchTimestamp];
    this.currentTimestamp = searchTimestamp;

    if (this.isHasSectors) {
        this.updateBarsSectors(stocks, this.data.topN, this.colorMode, true);
    } else {
        this.updateBarsNoSectors(stocks, this.data.topN, true);
    }

    if (this.data.timelineEntity) {
        const times = Object.keys(intervals).sort();
        const currentIndex = times.indexOf(searchTimestamp);
        this.data.timelineEntity.emit('timeline-update', {
            timestamp: searchTimestamp,
            index: currentIndex,
            total: times.length
        }, true);
    }


    this.calculateSectorLabelPosition?.(this.rotationData);
};
